import React from 'react'
import Link from 'gatsby-link'

//import logo from '../assets/images/logo.svg'

const Header = ({ logo, logoTitle, title, moto }) => (
  <header id="header" className="alt">
    <div className="logo">
      <img src={logo} alt="" />
      <p>{logoTitle}</p>
    </div>
    <h1>{title}</h1>
    <p>{moto}</p>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js